import controller from './wf-icon.controller';
import template from './wf-icon.html';
import './wf-icon.scss';

export default {
	controller,
	template,
	bindings: {
		wf: '<',
	},
};
